<template>
    <div>
        <div class="banner">
            <div class="headerReplacementDebtInfo"></div>
            <div class="banner-text">
                <b>{{ $t('billExchange.title') }}</b>
                <div class="breadcrumb">
                    <span><router-link to="/" class="pe-auto">{{ $t('billExchange.home') }}</router-link></span>
                    <span class="separator"></span>
                    <span>{{ $t('billExchange.menu') }}</span>
                    <span class="separator"></span>
                    <span><b>{{ $t('billExchange.title') }}</b></span>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="TabMenu">
                <DebtInfoTabMenu />
            </div>

            <div class="row mt-5 mb-5">
                <!-- Card 1 -->
                <div class="col-12 col-sm-6 col-md-4 mb-3">
                    <div class="card d-flex flex-column">
                        <img src="../../assets/bank-icon/kiatnakin-logo.png" class="card-img-top p-3"
                            alt="Kiatnakin Bank Logo">
                        <div class="card-body">
                            <h5 class="card-title">{{ $t('billExchange.banks.kkp.name') }}</h5>
                            <p class="card-text text-body-secondary">{{ $t('billExchange.banks.kkp.address') }}</p>
                            <a :href="$t('billExchange.banks.kkp.url')" target="_blank">
                                <button class="w-50 btn btn-outline-primary" type="button">{{ $t('billExchange.button')
                                }}</button>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- Card 2 -->
                <div class="col-12 col-sm-6 col-md-4 mb-3">
                    <div class="card d-flex flex-column">
                        <img src="../../assets/bank-icon/scb-logo.png" class="card-img-top p-3" alt="SCB Bank Logo">
                        <div class="card-body">
                            <h5 class="card-title">{{ $t('billExchange.banks.scb.name') }}</h5>
                            <p class="card-text text-body-secondary">{{ $t('billExchange.banks.scb.address') }}</p>
                            <a :href="$t('billExchange.banks.scb.url')" target="_blank">
                                <button class="w-50 btn btn-outline-primary" type="button">{{ $t('billExchange.button')
                                }}</button>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- Card 3 -->
                <div class="col-12 col-sm-6 col-md-4 mb-3">
                    <div class="card d-flex flex-column">
                        <img src="../../assets/bank-icon/kbank-logo.png" class="card-img-top p-3" alt="KBANK Logo">
                        <div class="card-body">
                            <h5 class="card-title">{{ $t('billExchange.banks.kbank.name') }}</h5>
                            <p class="card-text text-body-secondary">{{ $t('billExchange.banks.kbank.address') }}</p>
                        </div>
                    </div>
                </div>

                <!-- Card 4 -->
                <div class="col-12 col-sm-6 col-md-4 mb-3">
                    <div class="card d-flex flex-column">
                        <img src="../../assets/bank-icon/yuanta-logo.png" class="card-img-top p-3" alt="Yuanta Logo">
                        <div class="card-body">
                            <h5 class="card-title">{{ $t('billExchange.banks.yuanta.name') }}</h5>
                            <p class="card-text text-body-secondary">{{ $t('billExchange.banks.yuanta.address') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
  
<script>
import DebtInfoTabMenu from '@/components/DebtInfoTabMenu.vue';
import Highcharts from 'highcharts';
import store from "@/store";
import { mapState } from "vuex";
import { GET_FINANCIAL_DATA } from "../../store/actions.type";

export default {
    name: 'Info',
    components: {
        DebtInfoTabMenu,
    },
    data() {
        return {
            financialData: null,
        };
    },
    methods: {
        async init() {
            let response = await store.dispatch(GET_FINANCIAL_DATA);
            if (response) {
                this.financialData = response; // Assign fetched data to local state
            } else {
                console.error('Failed to fetch financial data');
            }
        },
    },

};
</script>
<style scoped>
.card {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.card-body {
    flex-grow: 1;
}
</style>
  